import { useMemo } from 'react';

import { useIsFocused } from '@garnish/core';
import { type Asset } from 'contentful';

import { useContentfulContentTypeEntries } from '@order/Contentful';

// ─────────────────────────────────────────────────────────────────────────────

export const useProductDetailsContentData = () => {
  const isScreenFocused = useIsFocused();

  // ─── Remote Data ─────────────────────────────────────────────────────

  const { data, fetching } = useContentfulContentTypeEntries<ContentEntry>({
    contentType: 'productDetails',
    limit: 500,
    pause: !isScreenFocused,
  });

  // ─── Derived Data ────────────────────────────────────────────────────

  const productDetailsContentData = useMemo(() => {
    if (!data) return;

    return new Map(data.map((item) => [item.fields?.baseProductSlug, item]));
  }, [data]);

  // ─────────────────────────────────────────────────────────────────────

  return {
    productDetailsContentData,
    isFetchingProductDetailsContentData: fetching,
  };
};

// ─── Types ───────────────────────────────────────────────────────────────────

type ContentEntry = {
  baseProductSlug: string;
  isEnabled?: boolean;
  cardHoverImage: Asset | undefined;
  cardHoverStaticImage: Asset | undefined;
  carousel?: { fields: { imageVideo: Asset; staticImage?: Asset } }[];
};
